/**
 * File: booksFormatUtils.ts
 * Path: apps/admin/src/shared/utils/booksFormatUtils.ts
 * Description: How balances and months read on the Accounting pages.
 */

import { formatCents } from "@idk/config";

/** A debit-minus-credit balance as "R 1 234,56 Dr" / "Cr", or "Nil". */
export const formatBalance = (cents: number): string =>
  cents === 0 ? "Nil" : `${formatCents(Math.abs(cents))} ${cents > 0 ? "Dr" : "Cr"}`;

const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

/** 2 → "February". */
export const monthName = (month: number) => MONTHS[month - 1] ?? "";
